export interface License {
  id: string;
  name: string;
  address: string;
  status: LicenseStatus;
  created_at: number;
  updated_at: number;
}

export enum LicenseStatus {
  OK = 'ok',
  PAYMENT_ERROR = 'payment_error',
  DISABLED = 'disabled',
}
